import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Get all reports accessible to the current user
 */
export const getAccessibleReports = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/reports`);
    return response.data;
  } catch (error) {
    console.error("Error fetching reports:", error.response?.data || error);
    throw error;
  }
};

/**
 * Get a specific report's definition (filters, columns, section options)
 */
export const getReportDefinition = async (reportId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/reports/${reportId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching report definition:", error.response?.data || error);
    throw error;
  }
};

/**
 * Run a report with the given parameters
 * @param {number} reportId - The report ID
 * @param {object} params - Report parameters (filters, sectionBy, pagination)
 */
export const runReport = async (reportId, params) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/reports/${reportId}/run`, params);
    return response.data;
  } catch (error) {
    console.error("Error running report:", error.response?.data || error);
    throw error;
  }
};
